export default __webpack_public_path__ + "static/media/sponsor_block.378e62d9.png";